import React from 'react';
import styled from 'styled-components';
import isNil from 'lodash/isNil';
import { IMeasureDisplayFormatFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import {
  getMeasureDisplayFormatKindLabel,
  measureDisplayFormatCalculationUnitLookup,
} from '../../../../utils/builder/measures/measureDisplayFormat/utils';
import * as BuilderInfoUI from '../../BuilderInfoUI';

interface IProps {
  format: IMeasureDisplayFormatFieldsFragment;
}

const Container = styled(BuilderInfoUI.HorizontalRow)`
  padding-right: 8px;
  padding-bottom: 8px;
  padding-left: 8px;
`;

const SimpleMeasureFormatDisplay = ({ format }: IProps) => {
  return (
    <Container>
      {format.kind && (
        <BuilderInfoUI.PlainInfo>
          <BuilderInfoUI.InfoLabel>Format Kind</BuilderInfoUI.InfoLabel>
          <BuilderInfoUI.PlainValue>
            {getMeasureDisplayFormatKindLabel(format.kind)}
          </BuilderInfoUI.PlainValue>
        </BuilderInfoUI.PlainInfo>
      )}
      {!isNil(format.decimalPlace) && (
        <BuilderInfoUI.PlainInfo>
          <BuilderInfoUI.InfoLabel>Precision</BuilderInfoUI.InfoLabel>
          <BuilderInfoUI.PlainValue>
            {format.decimalPlace}
          </BuilderInfoUI.PlainValue>
        </BuilderInfoUI.PlainInfo>
      )}
      {!isNil(format.calculationUnit) && !isNil(format.calculationValue) && (
        <BuilderInfoUI.PlainInfo>
          <BuilderInfoUI.InfoLabel>Calculation</BuilderInfoUI.InfoLabel>
          <BuilderInfoUI.PlainValue>
            {measureDisplayFormatCalculationUnitLookup[format.calculationUnit]}
            {format.calculationValue}
          </BuilderInfoUI.PlainValue>
        </BuilderInfoUI.PlainInfo>
      )}
      {!isNil(format.unit) && (
        <BuilderInfoUI.PlainInfo>
          <BuilderInfoUI.InfoLabel>Unit</BuilderInfoUI.InfoLabel>
          <BuilderInfoUI.PlainValue>{format.unit}</BuilderInfoUI.PlainValue>
        </BuilderInfoUI.PlainInfo>
      )}
    </Container>
  );
};

export default SimpleMeasureFormatDisplay;
